import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownTrigger',
  props: {
    handleClick: {
      type: Function,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})